import { Component, inject, input } from '@angular/core';
import { StyleSheetSpriteComponent } from '@features/styles/style-sheet-sprite/style-sheet-sprite.component';
import { StylesService } from '@features/styles/styles.service';
import { LpWebStyleSheetImageCanvasComponent } from '@typings/lp/generated';

@Component({
  selector: 'lp-web-style-sheet-image-canvas-component',
  imports: [StyleSheetSpriteComponent],
  templateUrl: './lp-web-style-sheet-image-canvas-component.component.html',
  styleUrl: './lp-web-style-sheet-image-canvas-component.component.css',
})
export class LpWebStyleSheetImageCanvasComponentComponent {
  readonly _stylesService = inject(StylesService);

  comp = input.required<LpWebStyleSheetImageCanvasComponent>();
}
